function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Close as CloseIcon } from '@mui/icons-material';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, Divider, IconButton, Switch, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ConfigContext } from './ConfigContext';
var PolicyModal = function PolicyModal(_ref) {
    var _configState$settings, _configState$settings2;
    var open = _ref.open, onClose = _ref.onClose, onSave = _ref.onSave, policy = _ref.policy, loading = _ref.loading;
    var _useState = useState(''), _useState2 = _slicedToArray(_useState, 2), policyName = _useState2[0], setPolicyName = _useState2[1];
    var _useState3 = useState([{
            id: '1',
            resource: '',
            actions: []
        }]), _useState4 = _slicedToArray(_useState3, 2), resourceActions = _useState4[0], setResourceActions = _useState4[1];
    var _useState5 = useState('Allow'), _useState6 = _slicedToArray(_useState5, 2), effect = _useState6[0], setEffect = _useState6[1];
    var _useState7 = useState(null), _useState8 = _slicedToArray(_useState7, 2), error = _useState8[0], setError = _useState8[1];
    var _useState9 = useState('preview'), _useState0 = _slicedToArray(_useState9, 2), jsonMode = _useState0[0], setJsonMode = _useState0[1];
    var _useState1 = useState(''), _useState10 = _slicedToArray(_useState1, 2), jsonString = _useState10[0], setJsonString = _useState10[1];
    var _useState11 = useState(null), _useState12 = _slicedToArray(_useState11, 2), jsonError = _useState12[0], setJsonError = _useState12[1];
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    var isEditMode = !!policy;
    // Function to generate JSON from current form state
    var generateJsonFromForm = function generateJsonFromForm() {
        var validResourceActions = resourceActions.filter(function (ra) {
            return ra.resource && ra.actions.length > 0;
        });
        return JSON.stringify({
            resourceType: 'Policy',
            id: isEditMode ? policy === null || policy === void 0 ? void 0 : policy.id : undefined,
            application_id: (policy === null || policy === void 0 ? void 0 : policy.application_id) || ['1'],
            name: policyName,
            effect: effect.toLowerCase(),
            resource_action: validResourceActions.map(function (ra) {
                return {
                    action: ra.actions,
                    applicationresource_id: [ra.resource]
                };
            }),
            details: {},
            metadata: {
                versionId: 1,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                createdBy: '',
                updatedBy: ''
            }
        }, null, 2);
    };
    // Function to sync form from JSON
    var syncFormFromJson = function syncFormFromJson(jsonText) {
        try {
            var parsed = JSON.parse(jsonText);
            // Update form fields
            if (parsed.name)
                setPolicyName(parsed.name);
            if (parsed.effect) {
                // Handle both lowercase and title case values
                var effectValue = parsed.effect.toLowerCase();
                setEffect(effectValue === 'allow' ? 'Allow' : 'Deny');
            }
            // Update resource actions
            if (parsed.resource_action && Array.isArray(parsed.resource_action)) {
                var newResourceActions = parsed.resource_action.map(function (ra, index) {
                    var _ra$applicationresour, _ra$resource;
                    return {
                        id: (index + 1).toString(),
                        resource: ((_ra$applicationresour = ra.applicationresource_id) === null || _ra$applicationresour === void 0 ? void 0 : _ra$applicationresour[0]) || ((_ra$resource = ra.resource) === null || _ra$resource === void 0 ? void 0 : _ra$resource[0]) || '',
                        actions: ra.action || []
                    };
                });
                setResourceActions(newResourceActions.length > 0 ? newResourceActions : [{
                        id: '1',
                        resource: '',
                        actions: []
                    }]);
            }
            setJsonError(null);
            return true;
        }
        catch (_unused) {
            setJsonError('Invalid JSON format');
            return false;
        }
    };
    // Handle JSON mode toggle
    var handleJsonModeToggle = function handleJsonModeToggle() {
        if (jsonMode === 'preview') {
            // Switching to edit mode - populate with current form state
            setJsonString(generateJsonFromForm());
            setJsonMode('edit');
        }
        else {
            // Switching to preview mode - try to sync form with JSON
            if (syncFormFromJson(jsonString)) {
                setJsonMode('preview');
            }
            // If sync failed, stay in edit mode to fix errors
        }
    };
    // Handle JSON text change
    var handleJsonChange = function handleJsonChange(newJsonText) {
        setJsonString(newJsonText);
        setJsonError(null);
    };
    useEffect(function () {
        if (policy) {
            setPolicyName(policy.name || '');
            // Normalize the effect value to match the switch component expectations
            var normalizedEffect = policy.effect ? policy.effect.toLowerCase() === 'allow' ? 'Allow' : 'Deny' : 'Allow';
            setEffect(normalizedEffect);
            // Parse existing resource_action array
            if (policy.resource_action && Array.isArray(policy.resource_action)) {
                var resourceActionPairs = policy.resource_action.map(function (ra, index) {
                    var _ra$applicationresour2, _ra$application_resou, _ra$resource2;
                    return {
                        id: (index + 1).toString(),
                        resource: ((_ra$applicationresour2 = ra.applicationresource_id) === null || _ra$applicationresour2 === void 0 ? void 0 : _ra$applicationresour2[0]) || ((_ra$application_resou = ra.application_resource) === null || _ra$application_resou === void 0 ? void 0 : _ra$application_resou[0]) || ((_ra$resource2 = ra.resource) === null || _ra$resource2 === void 0 ? void 0 : _ra$resource2[0]) || '',
                        actions: ra.action || []
                    };
                });
                setResourceActions(resourceActionPairs.length > 0 ? resourceActionPairs : [{
                        id: '1',
                        resource: '',
                        actions: []
                    }]);
            }
            else {
                setResourceActions([{
                        id: '1',
                        resource: '',
                        actions: []
                    }]);
            }
        }
        else {
            // Reset for new policy
            setPolicyName('');
            setEffect('Allow');
            setResourceActions([{
                    id: '1',
                    resource: '',
                    actions: []
                }]);
        }
        setError(null);
        setJsonMode('preview');
        setJsonError(null);
        // JSON string will be generated in preview mode
    }, [policy, open]);
    var handleSave = function handleSave() {
        var _parsedJsonData, _parsedJsonData2;
        var parsedJsonData = null;
        // If in JSON edit mode, validate and get parsed data
        if (jsonMode === 'edit') {
            try {
                parsedJsonData = JSON.parse(jsonString);
                // Sync form state for validation
                if (!syncFormFromJson(jsonString)) {
                    return; // Don't save if JSON is invalid
                }
            }
            catch (_unused2) {
                setJsonError('Invalid JSON format');
                return;
            }
        }
        // Use either parsed JSON data or form state for validation and data construction
        var nameToValidate = ((_parsedJsonData = parsedJsonData) === null || _parsedJsonData === void 0 ? void 0 : _parsedJsonData.name) || policyName;
        if (!(nameToValidate !== null && nameToValidate !== void 0 && nameToValidate.trim())) {
            setError('Policy name is required');
            return;
        }
        // Validate resource actions based on the source (JSON or form)
        var validResourceActions = [];
        if ((_parsedJsonData2 = parsedJsonData) !== null && _parsedJsonData2 !== void 0 && _parsedJsonData2.resource_action) {
            // Use resource actions from parsed JSON
            validResourceActions = parsedJsonData.resource_action.filter(function (ra) {
                var _ra$applicationresour3, _ra$resource3;
                return ra.action && ra.action.length > 0 && (((_ra$applicationresour3 = ra.applicationresource_id) === null || _ra$applicationresour3 === void 0 ? void 0 : _ra$applicationresour3[0]) || ((_ra$resource3 = ra.resource) === null || _ra$resource3 === void 0 ? void 0 : _ra$resource3[0]));
            });
        }
        else {
            // Use resource actions from form state
            validResourceActions = resourceActions.filter(function (ra) {
                return ra.resource.trim() && ra.actions.length > 0;
            }).map(function (ra) {
                return {
                    action: ra.actions,
                    applicationresource_id: [ra.resource]
                };
            });
        }
        if (validResourceActions.length === 0) {
            setError('At least one resource and action pair is required');
            return;
        }
        var policyData;
        if (parsedJsonData && jsonMode === 'edit') {
            var _policy$dateAdded;
            // Use the parsed JSON data directly when in JSON edit mode
            policyData = _objectSpread(_objectSpread({}, isEditMode && (policy === null || policy === void 0 ? void 0 : policy.id) && {
                id: policy.id
            }), {}, {
                // Include ID for edit mode
                name: parsedJsonData.name.trim(),
                effect: parsedJsonData.effect.toLowerCase(),
                // Ensure lowercase for API
                resource_action: validResourceActions,
                specification: jsonString,
                // Use the edited JSON string directly
                dateAdded: (_policy$dateAdded = policy === null || policy === void 0 ? void 0 : policy.dateAdded) !== null && _policy$dateAdded !== void 0 ? _policy$dateAdded : new Date().toLocaleDateString()
            });
        }
        else {
            var _policy$dateAdded2;
            // Use form state data (preview mode or no JSON editing)
            var resource_action = validResourceActions;
            policyData = _objectSpread(_objectSpread({}, isEditMode && (policy === null || policy === void 0 ? void 0 : policy.id) && {
                id: policy.id
            }), {}, {
                // Include ID for edit mode
                name: policyName.trim(),
                effect: effect.toLowerCase(),
                // Ensure lowercase for API
                resource_action: resource_action,
                specification: JSON.stringify({
                    resourceType: 'Policy',
                    id: isEditMode ? policy === null || policy === void 0 ? void 0 : policy.id : undefined,
                    application_id: (policy === null || policy === void 0 ? void 0 : policy.application_id) || 1,
                    name: policyName.trim(),
                    effect: effect.toLowerCase(),
                    resource_action: resource_action,
                    details: {},
                    metadata: {
                        versionId: 1,
                        createdDate: new Date().toISOString(),
                        updatedDate: new Date().toISOString(),
                        createdBy: '',
                        updatedBy: ''
                    }
                }, null, 2),
                dateAdded: (_policy$dateAdded2 = policy === null || policy === void 0 ? void 0 : policy.dateAdded) !== null && _policy$dateAdded2 !== void 0 ? _policy$dateAdded2 : new Date().toLocaleDateString()
            });
        }
        onSave(policyData);
    };
    var canSave = policyName.trim() && !loading;
    var getButtonText = function getButtonText() {
        if (loading)
            return 'Saving...';
        return isEditMode ? 'Update' : 'Add';
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "lg",
        fullWidth: true,
        PaperProps: {
            sx: {
                borderRadius: 2,
                boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.1)',
                height: '90vh',
                maxHeight: '700px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 1.5,
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            color: '#212121',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '20px'
        }
    }, isEditMode ? "Edit a policy in ".concat((configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.workspace_name) || 'Workspace') : "Add a policy to ".concat((configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.workspace_name) || 'Workspace')), /*#__PURE__*/ React.createElement(IconButton, {
        onClick: onClose,
        sx: {
            color: '#595959'
        }
    }, /*#__PURE__*/ React.createElement(CloseIcon, null))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flex: 1,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: '400px',
            p: 3,
            borderRight: '1px solid #ebebeb',
            overflow: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        fullWidth: true,
        size: "small",
        label: "Name",
        value: policyName,
        onChange: function onChange(e) {
            return setPolicyName(e.target.value);
        },
        required: true
    }), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            borderColor: '#ebebeb'
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: '#212121',
            fontSize: '14px',
            fontFamily: 'Open Sans'
        }
    }, "Deny"), /*#__PURE__*/ React.createElement(Switch, {
        checked: effect === 'Allow',
        onChange: function onChange(e) {
            return setEffect(e.target.checked ? 'Allow' : 'Deny');
        },
        size: "small",
        sx: {
            '& .MuiSwitch-switchBase.Mui-checked': {
                color: '#26890d',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#26890d',
                    opacity: 0.3
                }
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: '#212121',
            fontSize: '14px',
            fontFamily: 'Open Sans'
        }
    }, "Allow")), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error"
    }, error))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            color: '#212121',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '16px'
        }
    }, "JSON ", jsonMode === 'edit' ? 'Editor' : 'Preview'), /*#__PURE__*/ React.createElement(Button, {
        variant: jsonMode === 'edit' ? 'contained' : 'outlined',
        size: "small",
        onClick: handleJsonModeToggle,
        sx: {
            textTransform: 'none',
            borderColor: '#26890d',
            color: jsonMode === 'edit' ? '#ffffff' : '#26890d',
            backgroundColor: jsonMode === 'edit' ? '#26890d' : 'transparent',
            fontSize: '14px',
            fontWeight: 600,
            '&:hover': {
                borderColor: '#26890d',
                backgroundColor: jsonMode === 'edit' ? '#1f6b0a' : 'rgba(38, 137, 13, 0.04)'
            }
        }
    }, jsonMode === 'edit' ? 'Switch to Preview' : 'Edit JSON')), jsonError && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mx: 3,
            mt: 2
        }
    }, jsonError), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            display: 'flex',
            overflow: 'hidden'
        }
    }, jsonMode === 'preview' ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: '32px',
            backgroundColor: '#ffffff',
            p: 1,
            borderRight: '1px solid #f0f0f0',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        component: "pre",
        sx: {
            color: '#212121',
            fontSize: '14px',
            fontFamily: 'Open Sans',
            lineHeight: 1.62,
            margin: 0
        }
    }, Array.from({
        length: 30
    }, function (_, i) {
        return "".concat(i + 1, "\n");
    }).join(''))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            backgroundColor: '#f8f8f8',
            p: 2,
            overflow: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        component: "pre",
        sx: {
            color: '#000000',
            fontSize: '14px',
            fontFamily: 'Open Sans',
            lineHeight: 1.62,
            margin: 0,
            whiteSpace: 'pre-wrap'
        }
    }, function () {
        // Only show JSON if policy name is provided or it's edit mode
        if (!policyName.trim() && !isEditMode) {
            return '';
        }
        return generateJsonFromForm();
    }()))) :
        /*#__PURE__*/
        /* JSON Editor */
        React.createElement(Box, {
            sx: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 1,
                backgroundColor: '#f5f5f5',
                borderBottom: '1px solid #e0e0e0'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                color: '#666',
                fontSize: '12px'
            }
        }, "Edit the JSON directly. Changes will update the form when you switch back to preview mode."), /*#__PURE__*/ React.createElement(Button, {
            size: "small",
            onClick: function onClick() {
                return setJsonString(generateJsonFromForm());
            },
            sx: {
                textTransform: 'none',
                color: '#26890d',
                fontSize: '12px'
            }
        }, "Reset from Form")), /*#__PURE__*/ React.createElement(TextField, {
            multiline: true,
            fullWidth: true,
            value: jsonString,
            onChange: function onChange(e) {
                return handleJsonChange(e.target.value);
            },
            placeholder: "Enter JSON here...",
            variant: "outlined",
            sx: {
                flex: 1,
                '& .MuiOutlinedInput-root': {
                    height: '100%',
                    alignItems: 'flex-start',
                    fontFamily: 'monospace',
                    fontSize: '14px',
                    lineHeight: 1.62,
                    borderRadius: 0,
                    border: 'none',
                    '& fieldset': {
                        border: 'none'
                    }
                },
                '& .MuiInputBase-input': {
                    height: '100% !important',
                    overflow: 'auto !important',
                    resize: 'none',
                    padding: '16px'
                }
            }
        }))))), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            p: '16px 24px',
            gap: 1,
            borderTop: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onClose,
        variant: "outlined",
        sx: {
            textTransform: 'none',
            borderColor: '#d9d9d9',
            color: '#26890d',
            fontSize: '16px',
            fontWeight: 600,
            fontFamily: 'Open Sans',
            '&:hover': {
                borderColor: '#26890d',
                backgroundColor: 'transparent'
            }
        }
    }, "Cancel"), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleSave,
        variant: "contained",
        disabled: !canSave,
        sx: {
            textTransform: 'none',
            backgroundColor: '#26890d',
            color: '#ffffff',
            fontSize: '16px',
            fontWeight: 600,
            fontFamily: 'Open Sans',
            '&:hover': {
                backgroundColor: '#1f6b0a'
            },
            '&:disabled': {
                backgroundColor: '#d9d9d9',
                color: '#999'
            }
        }
    }, loading ? /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 20,
        color: "inherit"
    }) : getButtonText())));
};
export default PolicyModal;
